/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { FeeModuleV1, FeeModuleV1Interface } from "../FeeModuleV1";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "currency_",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "paymentRate_",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "treasury_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousCurrency",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nextCurrency",
        type: "address",
      },
    ],
    name: "CurrencyChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "previousPaymentRate",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "nextPaymentRate",
        type: "uint256",
      },
    ],
    name: "PaymentRateChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousTreasury",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "nextTreasury",
        type: "address",
      },
    ],
    name: "TreasuryChanged",
    type: "event",
  },
  {
    inputs: [],
    name: "currency",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "paymentRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "treasury",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
    constant: true,
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "payer",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "durationToReserve",
        type: "uint256",
      },
    ],
    name: "pay",
    outputs: [
      {
        internalType: "bool",
        name: "success",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "currency_",
        type: "address",
      },
    ],
    name: "setCurrency",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "paymentRate_",
        type: "uint256",
      },
    ],
    name: "setPaymentRate",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "treasury_",
        type: "address",
      },
    ],
    name: "setTreasury",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type FeeModuleV1ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: FeeModuleV1ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class FeeModuleV1__factory extends ContractFactory {
  constructor(...args: FeeModuleV1ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    currency_: string,
    paymentRate_: BigNumberish,
    treasury_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<FeeModuleV1> {
    return super.deploy(
      currency_,
      paymentRate_,
      treasury_,
      overrides || {}
    ) as Promise<FeeModuleV1>;
  }
  getDeployTransaction(
    currency_: string,
    paymentRate_: BigNumberish,
    treasury_: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      currency_,
      paymentRate_,
      treasury_,
      overrides || {}
    );
  }
  attach(address: string): FeeModuleV1 {
    return super.attach(address) as FeeModuleV1;
  }
  connect(signer: Signer): FeeModuleV1__factory {
    return super.connect(signer) as FeeModuleV1__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): FeeModuleV1Interface {
    return new utils.Interface(_abi) as FeeModuleV1Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): FeeModuleV1 {
    return new Contract(address, _abi, signerOrProvider) as FeeModuleV1;
  }
}
